export default __webpack_public_path__ + "static/media/Instagram.3b827daf.svg";